export default __webpack_public_path__ + "static/avatar-61da41c108013478477eed84f3e323b4.jpg";